import React from "react";
import { Alert, AlertDescription, AlertTitle } from "@capacit-com/lara-law-shared-ui";
import { FileSearch } from "lucide-react";

interface ConsolidationNotFoundBannerProps {
  hasFallbackHtml: boolean;
}

const ConsolidationNotFoundBanner: React.FC<
  ConsolidationNotFoundBannerProps
> = ({ hasFallbackHtml }) => {
  return (
    <Alert
      variant="default"
      className="mt-2 mb-4 border-muted-foreground/25 bg-muted/30"
    >
      <FileSearch className="text-muted-foreground" />
      <AlertTitle className="text-foreground">
        Konsolideret tekst er ikke tilgængelig
      </AlertTitle>
      <AlertDescription className="text-muted-foreground">
        {hasFallbackHtml
          ? "Der findes endnu ingen konsolideret tekst for det valgte tidspunkt eller ændringsdokument. Dokumentet vises i Retsinformation-original nedenfor."
          : "Der findes endnu ingen konsolideret tekst for det valgte tidspunkt eller ændringsdokument."}
      </AlertDescription>
    </Alert>
  );
};

export default ConsolidationNotFoundBanner;
